import { Row } from 'antd'
import styled from 'styled-components'

const StyledUnknownWordsModalRow = styled(Row)`
  flex: 1;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`

export default StyledUnknownWordsModalRow
